module.exports = __webpack_public_path__ + "static/media/33.bd8f984e.jpg";